/**
 * @ngdoc controllers
 * @memberof mercury.modules.cashup
 * @name CashupEditCtrl
 * @description Cashup editor page for entering the tender counts for each till and completing the cashup
 */
angular.module('mercury.modules.cashup.edit')
.controller('CashupEditCtrl', ["$location", "$scope", "$state", "$stateParams", "editable", "$resource", "$filter", "CashupSets", "$q", "dialog", "title", function($location, $scope, $state, $stateParams, editable, $resource, $filter, CashupSets, $q, dialog, title) {
  title.set('Cashup Reconciliation');
  //Define the reconcilliation API

  $scope.editable = editable;

  // List of tills that can be added to the cahup
  $scope.unusedTills = [];

  // temporary holding for cashups that have been removed and can be re-added without needing to query the server
  var removedCashups = [];

  $scope.tenderGroupColumns = [
    {label: 'Tender Type', type: 'string', key: 'label'},
    {label: 'Amount', type: 'number', key: 'systemAmount', filter: 'currency'}
  ];

  var updateUnusedTills = function() {
    var rtn = [];
    angular.forEach($scope.tills, function(till) {
      var shouldAdd = true;
      angular.forEach($scope.editModel.cashups, function(cashup) {
        if (cashup.tillIdentifier == till.id) {
          shouldAdd = false;
        }
      });
      if (shouldAdd) {
        rtn.push(till);
      }
    });
    $scope.unusedTills = rtn;
  };

  $scope.loading = $q.all({
    CashupSet: CashupSets.getCashupSet($stateParams.reconId),
    Tills: CashupSets.getTills()
  });

  $scope.loading.then(function(result) {
    $scope.editModel = result.CashupSet;
    // Create a comment variant that handles newlines in HTML rendering
    $scope.editModel.commentFormatted = ($scope.editModel.comment || '').replaceAll('\n', '<br>');

    $scope.tills = result.Tills;
    $scope.dayFor = moment($scope.editModel.date).mStartOf('day').format('dddd D MMM YYYY');

    // default the counted amounts for non-cash types to the system amount - with integrated eftpos these are almost always the same,
    // so users don't want to have to manually enter them all the time
    angular.forEach($scope.editModel.cashups, function(cashup) {
      angular.forEach(cashup.lines, function(cashupline) {
        if (cashup.datestampCounted === null && !cashupline.isCash) {
          cashupline.countedAmount = angular.copy(cashupline.systemAmount);
        }
      });
    });

    $scope.updateTotals();

    updateUnusedTills();
  });

  $scope.graphData = null;
  $scope.graphOptions = {
    sliceVisibilityThreshold: 0.05,
    tooltip: {
      showColorCode: true
    }
  };

  //Based on the cashup cashuplines, update the totals for the cashups and reconcilliation.
  $scope.updateTotals = function() {
    $scope.cashAmountCounted = 0;
    $scope.cashAmountSystem = 0;
    $scope.otherAmountCounted = 0;
    $scope.otherAmountSystem = 0;

    var tenderTotals = {};
    angular.forEach($scope.editModel.cashups, function(cashup) {
      cashup.cashAmountCounted = 0;
      cashup.cashAmountSystem = 0;
      cashup.otherAmountCounted = 0;
      cashup.otherAmountSystem = 0;

      angular.forEach(cashup.lines, function(cashupline) {
        if (typeof tenderTotals[cashupline.tenderTypeName] == 'undefined') {
          tenderTotals[cashupline.tenderTypeName] = {
            systemAmount: 0,
            countedAmount: 0,
            label: cashupline.tenderTypeName,
            isCash: cashupline.isCash
          };
        }

        tenderTotals[cashupline.tenderTypeName].systemAmount += cashupline.systemAmount;
        tenderTotals[cashupline.tenderTypeName].countedAmount += cashupline.countedAmount;

        if (cashupline.isCash) {
          cashup.cashAmountCounted += cashupline.countedAmount;
          cashup.cashAmountSystem += cashupline.systemAmount;
        } else {
          cashup.otherAmountCounted += cashupline.countedAmount;
          cashup.otherAmountSystem += cashupline.systemAmount;
        }
      });

      $scope.otherAmountSystem += cashup.otherAmountSystem;
      $scope.otherAmountCounted += cashup.otherAmountCounted;
      $scope.cashAmountSystem += cashup.cashAmountSystem;
      $scope.cashAmountCounted += cashup.cashAmountCounted;
    });

    $scope.tenderTotals = [];
    angular.forEach(tenderTotals, function(tenderTotal) {
      if (tenderTotal.systemAmount !== 0 || tenderTotal.countedAmount !== 0) {
        $scope.tenderTotals.push(tenderTotal);
      }

    });
    $scope.tenderTotals = $filter('orderBy')($scope.tenderTotals, 'systemAmount', true);
  };

  $scope.updateCashupCash = function(cashup) {
    angular.forEach(cashup.lines, function(cashupline) {
      if (cashupline.isCash) {
        cashupline.countedAmount = cashup.cashAmountCounted;
      }
    });

    $scope.updateTotals();
  };

  //Spread the new Reconcilliation actual cash value across the cashups based on the system cash ratio.
  $scope.updateTotalCash = function() {
    angular.forEach($scope.editModel.cashups, function(cashup) {
      var systemRatio = cashup.cashAmountSystem / $scope.cashAmountSystem;

      cashup.cashAmountCounted = $scope.cashAmountCounted * systemRatio;

      angular.forEach(cashup.lines, function(cashupline) {
        if (cashupline.isCash) {
          cashupline.countedAmount = $scope.cashAmountCounted * systemRatio;
        }
      });
    });
  };

  $scope.commit = function() {
    $scope.commitLoader = $q.defer();
    $scope.editModel.committed = true;
    $scope.editModel.$update(function() {
      $scope.commitLoader.resolve();
      $scope.returnToOverview();
    });
  };

  $scope.save = function() {
    $scope.saveLoader = $q.defer();
    $scope.editModel.$update(function() {
      $scope.saveLoader.resolve();
      $scope.returnToOverview();
    });
  };

  $scope.delete = function() {
    $scope.deleteLoader = $q.defer();
    $scope.editModel.$delete(function() {
      $scope.deleteLoader.resolve();
      $scope.returnToOverview();
    });
  };

  $scope.returnToOverview = function() {
    $state.go('Cashups.Overview', {report: JSON.stringify({type: 'week', time: moment($scope.editModel.datestampEnd).format()})});
  };

  /**
   * Remove a cashup from the set.
   */
  $scope.removeLine = function(index) {
    var removed = $scope.editModel.cashups.splice(index, 1);
    if (removed[0]) {
      removedCashups.push(removed[0]);
    }
    updateUnusedTills();
    $scope.updateTotals();
  };

  /**
   * Add a cashup to the set
   */
  $scope.addLine = function(tillIdentifier) {
    // check if it's in the removedCashups, if so then add it back from that list
    var found = false;
    angular.forEach(removedCashups, function(cashup, index) {
      if (cashup.tillIdentifier == tillIdentifier) {
        found = true;
        var removed = removedCashups.splice(index, 1);
        if (removed[0]) {
          $scope.editModel.cashups.push(removed[0]);
        }

        // default the counted amounts to the system amount for non-cash cashup lines
        angular.forEach(cashup.lines, function(cashupline) {
          if (cashup.timeCounted !== null && !cashupline.isCash) {
            cashupline.countedAmount = angular.copy(cashupline.systemAmount);
          }
        });
        updateUnusedTills();
        $scope.updateTotals();
      }
    });

    // otherwise, ask the server to give us a new cashup
    if (!found) {
      $scope.addLineLoader = CashupSets.addCashup(tillIdentifier, $scope.editModel.id);
      $scope.addLineLoader.then(function(result) {
        $scope.editModel.cashups.push(result.data);
        updateUnusedTills();
        $scope.updateTotals();
      });
    }
  };

  /*
   * display dialog for changing the end date of the CashupSets
   */
  $scope.changeEndDate = function() {
    dialog.open({
      templateUrl: 'modules/cashup/edit/changeenddate.tpl.html',
      scope: $scope
    }).then(function(finishType) {
      // do nothing if cancelled
      if (!finishType) {
        return;
      }

      $scope.loading = CashupSets.changeDate($scope.editModel.id, $scope.editModel.datestampEnd);
      $scope.loading.then(function(result) {
        var resultData = result.data;

        // once the cashupset is returned, with updated systemAmounts, we need to update our local model
        // and make sure that we reset any counted amounts
        $scope.editModel.datestampEnd = resultData.datestampEnd;
        angular.forEach(resultData.cashups, function(cashup) {
          var editModelCashup = null;
          angular.forEach($scope.editModel.cashups, function(editCashup) {
            if (editCashup.id == cashup.id) {
              editModelCashup = editCashup;
            }
          });
          if (editModelCashup === null) {
            editModel.cashups.push(cashup);
          } else {
            editModelCashup.datestampStart = cashup.datestampStart;
            editModelCashup.datestampEnd = cashup.datestampEnd;
            editModelCashup.cashAmountSystem = cashup.cashAmountSystem;
            editModelCashup.otherAmountsystem = cashup.otherAmountSystem;
          }

          angular.forEach(cashup.lines, function(line) {
            var editModelCashupLine = null;
            angular.forEach(editModelCashup.lines, function(editLine) {
              if (editLine.id == line.id) {
                editModelCashupLine = editLine;
              }
            });
            if (editModelCashupLine !== null) {
              editModelCashupLine.systemAmount = line.systemAmount;
              editModelCashupLine.countedAmount = line.countedAmount;
              if (editModelCashupLine.isCash) {
                editModelCashupLine.countedAmount = line.countedAmount;
              } else {
                editModelCashupLine.countedAmount = line.systemAmount;
              }
            }
          });
        });
        $scope.updateTotals();
      });
    });
  };
}]);
